/**
 * Strings de UI da `DegradedModeBadge` (Story E1.5.3).
 *
 * Extraído do componente pra não quebrar a regra
 * `react-refresh/only-export-components` (mesmo padrão de
 * `components/ui/utils/formHelpers.ts`). Centraliza também o texto
 * pt-BR caso queiramos i18n no futuro — único ponto de edição.
 */
export const DEGRADED_BADGE_TEXT = "Modo lento";
export const DEGRADED_BADGE_ARIA_LABEL = "Modo degradado de comunicação";
export const DEGRADED_TOOLTIP_CONTENT =
  "Modo degradado — usando SSE em vez de WebSocket. Notificações continuam chegando, mas com latência um pouco maior (até 30s).";
